<template>
	<div
		ref="chart"
		:style="{ width: $props.width, height: $props.height }"
	></div>
</template>
  
  <script>
import * as echarts from "echarts";

export default {
	name: "EChart",
	props: {
		options: {
			type: Object,
			required: true,
		},
		width: {
			type: String,
			default: "100%", // Default to 100% width
		},
		height: {
			type: String,
			default: "100%", // Default to 400px height
		},
	},
	computed: {
		chartWidth() {
			return this.width;
		},
		chartHeight() {
			return this.height;
		},
	},
	mounted() {
		this.initChart();
	},
	methods: {
		initChart() {
			const chart = echarts.init(this.$refs.chart);
			chart.setOption(this.options);
		},
	},
	watch: {
		options: {
			handler(newOptions) {
				this.initChart();
			},
			deep: true,
		},
	},
};
</script>
  
  <style scoped>
/* You can add some styles here if needed */
</style>
  